export default {"src":"/_next/static/media/discover-circular.5c9cbff9.svg","height":138,"width":139,"blurWidth":0,"blurHeight":0};